<template>
  <div class="success-page">
    <div class="success-card">
      <div class="success-icon">
        <v-icon size="44" color="success">mdi-check-circle-outline</v-icon>
      </div>

      <div class="success-title">Survey submitted successfully</div>
      <div class="success-subtitle">
        Your survey responses for this appointment have been submitted. You can save this survey as a
        template for future reuse.
      </div>

      <div class="success-actions">
        <div>
          <AppButtonFlat
            color="primary"
            prepend-icon="mdi-content-save-outline"
            @click="handleSaveAsTemplate"
          >
            Save as template
          </AppButtonFlat>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <AppButtonFlat
        variant="outlined"
        block
        prepend-icon="mdi-arrow-left"
        @click="router.push({ name: 'vendor.dashboard' })"
      >
        Back to Dashboard
      </AppButtonFlat>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useModalStore } from "@/shared/stores/modal";
import SaveSurveyTemplateModal from "@/modules/provider/components/SaveSurveyTemplateModal.vue";

const route = useRoute();
const router = useRouter();
const modal = useModalStore();

const submittedSurveyId = computed(() => {
  const raw =
    (route.query as any)?.id ??
    (route.params as any)?.id ??
    "";
  const n = Number(raw);
  return Number.isInteger(n) ? n : null;
});

function handleSaveAsTemplate() {
  modal.open(
    SaveSurveyTemplateModal,
    {
      surveyId: submittedSurveyId.value,
      onSave: async (payload: any) => {
        // TODO: wire up API when endpoint is available.
        // eslint-disable-next-line no-console
        console.log("save survey as template payload:", payload);
      },
    },
    { title: "Save as template" },
  );
}

</script>

<style scoped>
.success-page {
  padding: 12px;
}

.success-card {
  width: 100%;
  max-width: 560px;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #fff;
  padding: 18px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
}

.success-icon {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  display: grid;
  place-items: center;
  background: rgba(var(--v-theme-success), 0.08);
}

.success-title {
  font-weight: 900;
  color: var(--color-title, #0f172a);
}

.success-subtitle {
  font-size: 14px;
  color: var(--color-subtitle, #475569);
}

.success-actions {
  margin-top: 6px;
}
</style>
